














































































import { Component, Vue, Prop, Ref, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import EventBus from '@/plugins/EventBus'

@Component
export default class ComponentModalAlterarAluguelPrestador extends Vue {
  loadSaveAluguelPrestador: boolean = false
  $refs!: { formAluguelPrestador: any }

  formAluguelPrestadorRules: any = {
    valid: true,
    tipoAluguelPrestador: [(v: string) => !!v || 'Campo obrigatório'],
    valorAluguelPrestador: [
      (v: string) => !!v || 'Campo obrigatório',
      (v: string) => parseFloat(v) <= 100 || 'O valor percentual não pode ser maior que 100%',
    ],
  }

  get loadingSaveAluguelPrestador() { return this.loadSaveAluguelPrestador }
  set loadingSaveAluguelPrestador(value: boolean) { this.loadSaveAluguelPrestador = value }

  get modalAlterarAluguelPrestador() { return this.getFinanceiroStore.modal.modalAlterarAluguelPrestador }
  set modalAlterarAluguelPrestador(value: boolean) { this.getFinanceiroStore.setModal({ name: 'modalAlterarAluguelPrestador', value }) }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  get tipoAluguelPrestador() {
    return this.getFinanceiroStore.tipoAluguelPrestador
  }

  set tipoAluguelPrestador(value: string) {
    this.getFinanceiroStore.setTipoAluguelPrestador(value)
  }

  get valorAluguel() {
    return this.getFinanceiroStore.valorAluguelPrestador
  }

  set valorAluguel(value: string) {
    this.getFinanceiroStore.setValorAluguelPrestador(value)
  }

  get tipoAluguel() {
    return [
      { text: 'Fixo', value: 'Fixo' },
      { text: 'Percentual', value: 'Percentual' },
    ]
  }

  async saveAluguelPrestador() {
    if (this.$refs.formAluguelPrestador.validate()) {
      this.loadingSaveAluguelPrestador = true
      const response = await this.getFinanceiroStore.saveAluguelPrestador()
      if (response.success) {
        this.modalAlterarAluguelPrestador = false
        EventBus.$emit('setSnackbar', { show: true, text: `Aluguel prestador alterado com sucesso! ${String.fromCodePoint(0x1f642)}`, icon: 'done', color: '#2E7D32' })
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: response.message ? `${response.message} ${String.fromCodePoint(0x1f615)}` : `Ocorreu um erro na requisição. ${String.fromCodePoint(0x1f615)}`, icon: 'warning', color: '#C62828' })
      }
      this.loadingSaveAluguelPrestador = false
    }
  }

  @Watch('modalAlterarAluguelPrestador')
  onChangeModalAlterarAluguelPrestador(value: boolean) {
    if (!value) {
      this.$nextTick(() => {
        this.valorAluguel = ''
        this.tipoAluguelPrestador = ''
        this.$refs.formAluguelPrestador.resetValidation()
      })
    }
  }
}
